import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import React from 'react'
import { Link } from 'react-router-dom'
import { PropsWithChildrenRequired } from '../../../types/PropsWithChildrenRequired'

type Props = {
    to: string
    className?: string
    isExternal?: boolean
    target?: string
}

function CtxtLink({
    to,
    children,
    className,
    isExternal = false,
    target = '_blank',
}: PropsWithChildrenRequired<Props>): React.JSX.Element {
    const finalClasses = clsx(
        {
            'text-ctxt-blue hover:underline text-nowrap': isExternal,
            'text-ctxt-blue hover:underline': !isExternal,
        },
        className,
    )

    if (isExternal) {
        return (
            <a
                href={to}
                target={target}
                rel="noopener noreferrer"
                className={finalClasses}
            >
                {children}
                <FontAwesomeIcon
                    icon={faUpRightFromSquare}
                    className={`w-3 ml-1`}
                />
            </a>
        )
    }

    // internal link
    return (
        <Link to={to} className={finalClasses}>
            {children}
        </Link>
    )
}

export default CtxtLink
